// Allowed extensions and MIME types, kept free of generated-schema imports so
// components can pull an `accept` list without loading the whole GraphQL schema.
// FILE_TYPE_POLICIES in ./fileTypePolicies maps these onto UploadedFileType.

// Formats stored for download only — the app does not render them inline.
export const ATTACHMENT_EXTENSIONS = ['doc', 'docx', 'mp3', 'csv']

export const UNSIGNED_EXTENSIONS = ['doc', 'docx', 'csv']

export const ATTACHMENT_MIMES = [
  'application/msword',
  'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
  'audio/mpeg',
  'audio/mp3',
  'text/csv',
  // Windows reports .csv as an Excel type
  'application/vnd.ms-excel',
]

export const IMAGE_EXTENSIONS = ['png', 'jpg', 'jpeg']

export const IMAGE_MIMES = ['image/jpg', 'image/jpeg', 'image/png']

export const MEDIA_EXTENSIONS = [
  ...IMAGE_EXTENSIONS,
  'pdf',
  'mp4',
  'mov',
  'mpg',
  'mpeg',
]

export const MEDIA_MIMES = [
  ...IMAGE_MIMES,
  'video/mp4',
  'video/quicktime',
  'video/mpeg',
  'video/mpg',
  'application/pdf',
]

// Every incident attachment surface uses the same format contract: manual
// incident creation, incident notes, and both Quick Report upload flows.
export const INCIDENT_ATTACHMENT_EXTENSIONS = [
  ...MEDIA_EXTENSIONS,
  ...ATTACHMENT_EXTENSIONS,
]

export const INCIDENT_ATTACHMENT_MIMES = [...MEDIA_MIMES, ...ATTACHMENT_MIMES]

export const toAcceptList = (extensions: string[]) =>
  extensions.map((extension) => `.${extension}`)
